<template>
  <TheFooter>
    <div>
      <!--footer-->
      <a href="#">Shopio</a>
      <span class="ml-1">&copy; {{ new Date().getFullYear() }}</span>
    </div>
    <div class="ml-auto">
      <a href="http://jissjohnson.info" target="_blank">
        <span class="mr-1">Powered by Shopio</span>
      </a>
    </div>
  </TheFooter>
</template>
<script>
import { Footer as TheFooter } from "@coreui/vue";
export default {
  name: "DefaultFooter",
  components: {
    TheFooter,
  },
};
</script>
